export const generativeAiAgentsTags = "/generative_ai/agents/tags";
